import { PageHero, CtaBand } from "@/components/Blocks";
import LocationSwitcher from "@/components/LocationSwitcher";
import { Marquee } from "@/components/Strips";
import { Reveal } from "@/components/motion";
import { LOCATIONS, IMG } from "@/data/content";

export default function Locations() {
  return (
    <main data-testid="locations-page">
      <PageHero
        testId="locations-hero"
        eyebrow="Global bespoke delivery"
        lines={["Confidential,", "wherever you are."]}
        intro="Online confidential sessions worldwide, No. 2 Harley Street in London, a private mountain retreat in Andalusia, or your own residence anywhere in the world."
        image={IMG.s2}
      />
      <LocationSwitcher withHead={false} />
      <Marquee />
      <section className="bg-[#070A12] py-24 sm:py-32">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {LOCATIONS.map((l, i) => (
            <Reveal key={l.id} delay={i * 0.08} data-testid={`location-card-${l.id}`}>
              <div className="group">
                <div className="aspect-[3/4] overflow-hidden bg-[#131B2E]">
                  <img src={l.image} alt={l.title} className="w-full h-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-[1200ms]" />
                </div>
                <p className="mt-5 font-data text-[11px] tracking-[0.2em] uppercase text-[#C5A059]">{l.region}</p>
                <h3 className="font-display text-2xl text-slate-50 mt-2">{l.title}</h3>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CtaBand />
    </main>
  );
}
